<ng-container *ngIf="!showExport">
  <payarc-page-header title="Disputes"></payarc-page-header>

  <div class="dsp-kpis">
    <payarc-stat-tile label="Needs response" [value]="needsResponseCount" accent="var(--pa-coral)"></payarc-stat-tile>
    <payarc-stat-tile label="Won" [value]="wonCount" accent="var(--pa-mint)"></payarc-stat-tile>
    <payarc-stat-tile label="Lost" [value]="lostCount" accent="var(--pa-navy)"></payarc-stat-tile>
    <payarc-stat-tile label="Win rate" [value]="disputeWinRate !== null ? disputeWinRate + '%' : '--'" note="won of resolved" accent="var(--pa-blue-light)"></payarc-stat-tile>
  </div>

  <payarc-filter-bar class="dsp-filter-row">
    <div class="pa-row pa-gap-8">
      <label for="disputeFilterType">Type</label>
      <select id="disputeFilterType" class="pa-input" [(ngModel)]="filterOnSelected" (ngModelChange)="setUrl()">
        <option *ngFor="let obj of filterOn" [value]="obj.key">{{obj.text}}</option>
      </select>
    </div>
    <div class="pa-row pa-gap-8">
      <span id="disputeDateRangeLabel">Date range</span>
      <input type="text" class="pa-input" aria-labelledby="disputeDateRangeLabel" aria-label="From date"
             [matDatepicker]="dp" placeholder="From" (click)="dp.open()" [max]="toDate" [(ngModel)]="fromDate" readonly />
      <mat-datepicker #dp (closed)="setUrl()"></mat-datepicker>
      <input type="text" class="pa-input" aria-labelledby="disputeDateRangeLabel" aria-label="To date"
             [matDatepicker]="dp1" [(ngModel)]="toDate" placeholder="To" (click)="dp1.open()" [min]="fromDate" readonly />
      <mat-datepicker #dp1 (closed)="setUrl()"></mat-datepicker>
    </div>
    <app-filter actions [filter_storage_key]="filter_storage_key" [count_storage_key]="count_storage_key" [filter]="filter"></app-filter>
    <button actions type="button" payarcButton="primary" (click)="exportexcel()">Export</button>
  </payarc-filter-bar>

  <div class="dsp-top">
    <payarc-section-card heading="Dispute resolution" [sub]="disputeTotalCount + ' disputes'" class="dsp-res">
      <ng-container *ngIf="disputeDonutSegments.length > 0">
        <payarc-donut [segments]="disputeDonutSegments" [centerValue]="disputeTotalCount" centerLabel="disputes"></payarc-donut>
        <div class="dsp-winrate" *ngIf="disputeNewCount !== null">
          <b>{{disputeNewCount}}</b> new chargebacks <span>&middot; {{disputeFollowUpCount}} follow-ups (reversals, pre-arbitration, credits)</span>
        </div>
        <div class="dsp-winrate">
          <b>{{respondedCount}}</b> responded <span>&middot; {{needsResponseCount}} not responded</span>
        </div>
        <div class="dsp-winrate" *ngIf="disputeWinRate !== null">
          <b>{{disputeWinRate}}%</b> win rate <span>&middot; {{wonCount}} won of {{wonCount + lostCount}} resolved</span>
        </div>
      </ng-container>
      <payarc-empty-state
        *ngIf="!loadFlag2 && disputeDonutSegments.length === 0"
        [title]="chartErrorMsg ? 'Dispute resolution unavailable' : 'No disputes in this period'"
        [message]="chartErrorMsg"
      ></payarc-empty-state>
    </payarc-section-card>

    <div class="dsp-charts-stack">
      <payarc-section-card heading="Dispute volume">
        <payarc-bar-chart
          *ngIf="volumeBarSeries[0]?.values?.length > 0"
          [categories]="volumeBarCategories"
          [series]="volumeBarSeries"
          [line]="volumeRatioLine"
          [height]="170"
          prefix="$"
        ></payarc-bar-chart>
        <payarc-empty-state
          *ngIf="!loadFlag2 && !(volumeBarSeries[0]?.values?.length > 0)"
          [title]="chartErrorMsg ? 'Dispute volume unavailable' : 'No dispute volume data'"
          [message]="chartErrorMsg"
        ></payarc-empty-state>
      </payarc-section-card>
      <payarc-section-card heading="Dispute count">
        <payarc-bar-chart
          *ngIf="countBarSeries[0]?.values?.length > 0"
          [categories]="countBarCategories"
          [series]="countBarSeries"
          [line]="countRatioLine"
          [height]="170"
          prefix=""
        ></payarc-bar-chart>
        <payarc-empty-state
          *ngIf="!loadFlag2 && !(countBarSeries[0]?.values?.length > 0)"
          [title]="chartErrorMsg ? 'Dispute count unavailable' : 'No dispute count data'"
          [message]="chartErrorMsg"
        ></payarc-empty-state>
      </payarc-section-card>
    </div>
  </div>

  <payarc-search placeholder="Search" [value]="searchKeyword || ''" (valueChange)="onSearch($event)" class="dsp-search"></payarc-search>

  <payarc-section-card [flush]="true">
    <div class="pa-table-wrap">
      <payarc-table>
        <thead>
          <tr>
            <th>Chargeback date</th>
            <th>Case number</th>
            <th>Primary / Secondary</th>
            <th>Transaction date</th>
            <th class="num">Amount</th>
            <th>Reason</th>
            <th>Case type</th>
            <th>RDR</th>
            <th>Status</th>
            <th>Card number</th>
            <th>Responded</th>
            <th>Respond by</th>
            <th>Last updated</th>
          </tr>
        </thead>
        <tbody>
          <ng-container *ngIf="loadFlag">
            <tr class="pa-skeleton-row" *ngFor="let r of [1,2,3,4,5]">
              <td *ngFor="let c of [1,2,3,4,5,6,7,8,9,10,11,12,13]"><span class="pa-skeleton-bar"></span></td>
            </tr>
          </ng-container>

          <tr *ngIf="!loadFlag && errorMsg">
            <td class="pa-table__state-cell" colspan="13">
              <payarc-empty-state title="No disputes found" [message]="errorMsg"></payarc-empty-state>
            </td>
          </tr>

          <ng-container *ngIf="!loadFlag && disputeList && !errorMsg">
            <tr *ngFor="let dispute of disputeList.data" tabindex="0" (click)="openDispute($event, dispute)" (keydown.enter)="openDispute($event, dispute)" (keydown.space)="$event.preventDefault(); openDispute($event, dispute)">
              <td class="muted">{{dispute.report_date ? (dispute.report_date | date: 'MM/dd/yyyy') : '--'}}</td>
              <td class="strong">{{dispute.case_number ? dispute.case_number : '--'}}</td>
              <td class="muted">{{dispute.is_primary_case ? 'Primary' : 'Secondary'}}</td>
              <td class="muted">{{dispute.transaction_date ? (dispute.transaction_date | date: 'MM/dd/yyyy') : '--'}}</td>
              <td class="num">{{dispute.case_amount ? ('-' + ((dispute.case_amount) | currency: 'USD' : 'symbol')) : '--'}}</td>
              <td>{{dispute.reason_desc ? (dispute.reason_desc | camalizeStr : true) : '--'}}</td>
              <td class="muted" [title]="dispute.case_type ? dispute.case_type : ''">{{dispute.case_type ? (dispute.case_type | camalizeStr : true) : '--'}}</td>
              <td class="muted">{{dispute.rdr_indicator === 1 ? 'Y' : '--'}}</td>
              <td><payarc-status-badge [status]="dispute.status" [variant]="statusVariant(dispute.status)"></payarc-status-badge></td>
              <td>
                <span class="pa-card-cell">
                  <img class="card-img" alt="" *ngIf="dispute.card_type"
                       [src]="card_img_obj[dispute.card_type] ? card_img_obj[dispute.card_type] : '../../../../assets/images/card-default.png'" />{{dispute.card_number ? dispute.card_number : '--'}}
                </span>
              </td>
              <td class="muted"><a [routerLink]="redirect_link" [queryParams]="{id: dispute.id}">{{dispute.case_submitted ? 'Responded' : 'Not responded'}}</a></td>
              <td class="muted">{{dispute.responded_date ? (dispute.responded_date | date: 'MM/dd/yyyy') : '--'}}</td>
              <td class="muted">{{dispute.last_updated_date ? (dispute.last_updated_date | date: 'MM/dd/yyyy') : '--'}}</td>
            </tr>
          </ng-container>
        </tbody>
      </payarc-table>
    </div>

    <div class="dsp-pager-row" *ngIf="disputeList?.meta?.pagination?.total">
      <label class="dsp-pager-row__limit">
        Rows per page
        <select class="pa-input" [(ngModel)]="limit" (change)="setUrl(1, false)">
          <option *ngFor="let no of limitArray" [value]="no">{{ no }}</option>
        </select>
      </label>
      <payarc-pager
        [rangeLabel]="pagerRangeLabel"
        [pages]="pagerPages"
        [currentPage]="currentPage"
        [disablePrev]="currentPage <= 1"
        [disableNext]="currentPage >= totalPages"
        (prev)="pagerPrev()"
        (next)="pagerNext()"
        (pageSelect)="pagerSelect($event)"
      ></payarc-pager>
    </div>
  </payarc-section-card>
</ng-container>

<div *ngIf="showExport">
  <app-export-excel [exportExcel]="exportExcel" [serviceName]="exportData" [filterUrl]="filterPostFix" [searchData]="searchKeyword"></app-export-excel>
</div>
